import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BASIC_BUTTONS_CONFIRMATION } from '@app/shared/common/constants';
import { LogoutFallbackRouteData } from '@app/shared/common/models/logout-fallback-route-data.model';
import { Confirmation, ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs';

const CONFIRM_LOG_OUT_MESSAGE: Confirmation = {
  ...BASIC_BUTTONS_CONFIRMATION,
  header: 'End Session',
  message: 'Are you sure you want to sign out?',
  rejectLabel: 'Stay Signed In',
  acceptLabel: 'Sign Out',
};

export const logoutConfirmationGuard: CanActivateFn = () => {
  const router = inject(Router);
  const confirmationService = inject(ConfirmationService);

  return new Observable<boolean>((observer) => {
    confirmationService.confirm({
      ...CONFIRM_LOG_OUT_MESSAGE,
      accept: () => {
        observer.next(true);
        observer.complete();
      },
      reject: () => {
        observer.next(false);
        observer.complete();
        const fallbackUrl = getFallbackUrlFromRoute(router);

        if (fallbackUrl) {
          router.navigateByUrl(fallbackUrl);
        }
      },
    });
  });
};

function getFallbackUrlFromRoute(router: Router): string | null {
  let currentRoute = router.routerState.snapshot.root;
  while (currentRoute.firstChild) {
    currentRoute = currentRoute.firstChild;
  }

  const snapshots = currentRoute.pathFromRoot;

  for (let i = snapshots.length - 1; i >= 0; i--) {
    const data = snapshots[i].data as LogoutFallbackRouteData;

    if (data.logoutFallbackUrl) {
      return data.logoutFallbackUrl;
    }
  }

  return null;
}
